/* eslint-disable sort-imports */ // <--- need to keep this specific order
import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

// ===== Route Imports =====
import AdminFacilitiesRoutes from "@/router/routes/admin-facilities";
import ARRoutes from "@/router/routes/modules/accounts-receivable";
import AuthRoutes from "@/router/routes/auth";
import AlertsRoutes from "@/router/routes/alerts";
import CallListRoutes from "@/router/routes/call-list";
import DashboardRoutes from "@/router/routes/dashboard";
import DispositionsRoutes from "@/router/routes/dispositions";
import DocumentManagerRoutes from "@/router/routes/document-manager";
import FacilitiesRoutes from "@/router/routes/facilities";
import GiftCardRoutes from "@/router/routes/gift-cards";
import ReportingRoutes from "@/router/routes/reporting";
import SettingsRoutes from "@/router/routes/settings";
import TenantRoutes from "@/router/routes/tenant";
import UserRoutes from "@/router/routes/user";

Vue.use(Router);

// const localStorage.getItem("arActive") = localStorage.getItem("localStorage.getItem("arActive);
const facilityId = localStorage.getItem("facilityId");
const tenantId = localStorage.getItem("tenantId");
const activeDashboard = localStorage.getItem("arActive") ? "/accounts-receivable" : "/";
const activeCallView = localStorage.getItem("arActive")
  ? `/accounts-receivable/facilities/${facilityId}/tenant/${tenantId}`
  : `/facilities/${facilityId}/details`;

export function ifNotAuthenticated(to, from, next) {
  if (!store.state.auth.access_token) {
    next();
    return;
  }
  // user has auth'd, send em back to the dashboard
  next(activeDashboard);
}

export function ifAuthenticated(to, from, next) {
  if (store.state.auth.access_token) {
    next();
    return;
  }
  // user has not auth'd, send em to the login page
  next("/login");
}

export function ifAuthenticatedButNotOnCall(to, from, next) {
  if (store.state.auth.access_token) {
    // user has auth'd
    if (localStorage.getItem("callStarted")) {
      // call active, cannot return to dashboard
      next(activeCallView);
      return;
    }
    // no call active, can access dashboard
    next();
    return;
  }
  // user has not auth'd, send em to the login page
  next("/login");
}

export function ifValidSalesCall(to, from, next) {
  const validSalesDestinations = ["tenantDetails", "facilityDetails", "search"];
  if (store.state.auth.access_token) {
    // user has auth'd
    if (validSalesDestinations.includes(to.name) && localStorage.getItem("callStarted")) {
      // sales call is valid
      next();
      return;
    } else {
      // sales call invalid, cannot proceed
      next(activeDashboard);
      return;
    }
  }
  // user has not auth'd, send em to the login page
  next("/login");
}

export function ifValidArCall(to, from, next) {
  const validArDestination = ["arTenant", "arTenantSearch", "promiseToPay", "paymentPlan"];
  if (store.state.auth.access_token) {
    // user has auth'd
    if (validArDestination.includes(to.name) && localStorage.getItem("callStarted")) {
      // a/r call is valid
      next();
      return;
    } else {
      // a/r call invalid, cannot proceed
      next(false);
      return;
    }
  }
  // user has not auth'd, send em to the login page
  next("/login");
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...AdminFacilitiesRoutes,
    ...ARRoutes,
    ...AuthRoutes,
    ...AlertsRoutes,
    ...CallListRoutes,
    ...DashboardRoutes,
    ...DispositionsRoutes,
    ...DocumentManagerRoutes,
    ...FacilitiesRoutes,
    ...GiftCardRoutes,
    ...ReportingRoutes,
    ...SettingsRoutes,
    ...TenantRoutes,
    ...UserRoutes
  ]
});
